{
  "concept": ["K33", "I30", "X13", "F42", "K34", "K36", "R37", "S10"],
  "note": "Phase Kern (Fabi, 16.10.2026): Systeme werden ausgeblendet, nicht gelöscht. on: false heißt aus. review nennt die Phase, in der wir prüfen, ob es wieder an soll (Fabi: nichts darf in Vergessenheit geraten).",
  "systems": {
    "wind": {
      "on": false,
      "name": "Wind",
      "what": "Ab „Aufziehend“ schieben Böen die Freunde übers Ufer, Eichhörnchen werden vom Baum gepustet.",
      "why": "Freunde rutschen ohne sichtbaren Grund weg, die Aufstellung verpufft.",
      "review": "Vertical Slice",
      "reviewWhy": "wenn man Böen und Wetter im Bild sieht"
    },
    "edgeOut": {
      "on": false,
      "name": "Über den Rand",
      "what": "Wer oft gegen die Kante geschubst wird, fällt aus dem Kampf und wartet dort. Der Rammstoß schubst weiter, aber niemand fällt hinaus.",
      "why": "Die Kante hatte einen unsichtbaren Zähler; plötzlich fehlte jemand.",
      "review": "Grundsätze",
      "reviewWhy": "zusammen mit Gelände auf dem Ufer"
    },
    "march": {
      "on": false,
      "name": "Marschrichtung",
      "what": "Beim Aufstellen einen Pfeil ziehen, den ein Freund zu Kampfbeginn abläuft; ein Teil der Sturmwesen läuft ebenfalls los. Mit ihr ist die Tempo-Liste beim Aufstellen ausgeblendet.",
      "why": "Ein zusätzlicher Handgriff bei jedem Freund, Gegner laufen kreuz und quer; Aufstellen war „zu mühsam“.",
      "review": "Grundsätze",
      "reviewWhy": "wenn es darum geht, beim Aufstellen mehr abzuwägen"
    },
    "secondJump": {
      "on": false,
      "name": "Zweiter Sprung",
      "what": "Windschnitt und Nieselchen springen mit ihrem Kniff ein zweites Mal nach hinten. Ausgeschaltet springen sie nur einmal, ihr Kniff ist dann ein harter Hieb an Ort und Stelle.",
      "why": "Hinten war nie sicher; Aufstellen fühlte sich wie Hoffnung an.",
      "review": "Grundsätze",
      "reviewWhy": "zusammen mit der Frage, wen die Gegner anvisieren"
    },
    "lightning": {
      "on": true,
      "name": "Blitze",
      "what": "Ab „Nah“ schlagen Blitze zufällig ein, betäuben getroffene Freunde kurz und machen getroffene Sturmwesen schneller. Bleibt an (Fabi: „blitze finde ich schon irgendwie wichtig“).",
      "why": "Das Unwetter soll im Kampf spürbar bleiben.",
      "review": "Spielen mit Freunden",
      "reviewWhy": "bleibt an; nur der Schaden ist aus"
    },
    "lightningDamage": {
      "on": false,
      "name": "Schaden durch Blitze",
      "what": "Ein Blitz verletzt die Freunde, die er trifft. Ausgeschaltet betäubt er nur, dafür eine Viertelsekunde länger.",
      "why": "Zufälliger Schaden, gegen den man nichts tun kann: Abschiede aus Pech statt aus Entscheidungen.",
      "review": "Spielen mit Freunden",
      "reviewWhy": "wenn andere spielen und wir sehen, ob das Unwetter im Kampf genug spürbar ist; die Phase Kern ist ohne Endtest geschlossen (29.10.2026), bis dahin bleibt der Schaden aus"
    },
    "smallTimeCosts": {
      "on": false,
      "name": "Kleine Zeitkosten",
      "what": "Jeder Kauf kostet 6 min, jeder Versuch (etwa beim Entwirren) 9 min. Ausgeschaltet kosten Kaufen und Versuche keine Zeit; nur beim Ratespiel des Fuchses kostet jeder Tipp weiter Zeit.",
      "why": "Kleinstbeträge, die man nicht im Kopf behält (Fabi: „Zeitkosten ist mir egal“).",
      "review": "Spielen mit Freunden",
      "reviewWhy": "beim Balancing mit anderen; die Phase Kern ist ohne Endtest geschlossen (29.10.2026), bis dahin bleiben sie aus"
    },
    "firstFallFarewell": {
      "on": false,
      "name": "Abschied beim ersten Fall",
      "what": "Wer im Kampf fällt, nimmt sofort Abschied. Ausgeschaltet kommt er verwundet zurück an Bord; erst wer verwundet noch einmal fällt, nimmt Abschied, und die Nacht heilt die Wunde.",
      "why": "Gut gespielt gingen 4 bis 5 Freunde pro Run, meist durch einen einzelnen Treffer statt durch eine Entscheidung (Fabi: „Lass uns A nehmen“, die Wunde).",
      "review": "Spielen mit Freunden",
      "reviewWhy": "beim Balancing mit anderen: Kommen Abschiede aus Entscheidungen statt aus Pech? Die Phase Kern ist ohne Endtest geschlossen (29.10.2026)"
    },
    "retreat": {
      "on": false,
      "name": "Rückzug im Kampf",
      "what": "Haben die Sturmwesen anteilig deutlich mehr Leben übrig als der Landtrupp, laufen alle zum Boot; aus der Begegnung gibt es dann nichts. Ausgeschaltet kämpft der Landtrupp bis zum Ende, und wer fällt, kommt verwundet zurück (F42). Mit ihm ist der Hasenfuß ausgeblendet.",
      "why": "Fabi (17.10.2026 nachts): Ein Dachs gegen vier Hagelchen floh, statt sie nach und nach auszuschalten, und fiel auf der Flucht. Seit es die Wunde gibt, braucht es den Rückzug nicht mehr, damit Freunde nicht für immer gehen.",
      "review": "Grundsätze",
      "reviewWhy": "zusammen mit dem Knopf, mit dem man mitten im Kampf zurückholt"
    },
    "stormDrift": {
      "on": false,
      "name": "Alte Sturmuhr",
      "what": "Vorbeitreiben holt eine halbe Stunde Vorsprung zurück, mit dem Sturm kommen mehr Sturmwesen ans Ufer, und wer eingeholt ist, muss an jeder Anlegestelle kämpfen. Wie weit es bis zum Durchlass ist, sieht man erst kurz vorher.",
      "why": "Fabi hat das Unwetter als Uhr gewählt (R38): Der Tag ist ein Vorrat an Zeit, der Durchlass das Ziel, und jeder Sieg unterwegs bereitet auf ihn vor.",
      "review": "Spielen mit Freunden",
      "reviewWhy": "beim Balancing mit anderen; das Unwetter als Uhr bleibt für die erste Fassung (29.10.2026)"
    },
    "retreatChoice": {
      "on": false,
      "name": "Rückzug wählen",
      "what": "Vor jedem Kampf wählt man, ab wann sich der Landtrupp zurückzieht (vorsichtig, normal, mutig, bis zum Letzten). Ausgeschaltet gilt immer „normal“, mit dem Hasenfuß „ängstlich“.",
      "why": "Eine Wahl vor jedem Kampf, die man fast immer auf „normal“ ließ (Fabi: „Deine Idee zum Rückzug finde ich einleuchtend“).",
      "review": "Grundsätze",
      "reviewWhy": "zusammen mit dem Knopf, mit dem man mitten im Kampf zurückholt"
    },
    "recruitWhenShort": {
      "on": false,
      "name": "Neue aus Not",
      "what": "Ist die Truppe kaum größer als das Ufer, kommen öfter Tiere des Wegs, und an späteren Tagen bittet früh eins, mitkommen zu dürfen. Ausgeschaltet kommen Neue gleichmäßig; die frühe Bewerbung am ersten Tag bleibt.",
      "why": "Man nahm jeden, den man kriegen konnte (Fabi: „Ich soll das Tier mitnehmen, weil ich es mag … und nicht, weil ich zu wenig Tiere an Bord habe“).",
      "review": "Spielen mit Freunden",
      "reviewWhy": "beim Balancing mit anderen: Ist die Truppe ab Tag 2 größer als das Ufer? Die Phase Kern ist ohne Endtest geschlossen (29.10.2026)"
    },
    "weakTargetSwitch": {
      "on": false,
      "name": "Wechsel aufs schwache Ziel",
      "what": "Steht ein Freund mit weniger als halb so viel Leben in Reichweite, wechselt ein Gegner zu ihm. Ausgeschaltet wechseln Gegner nur, wenn jemand deutlich näher steht.",
      "why": "Ein Grund für „richtig dumm gestorben“: Den Wechsel konnte man weder vorhersehen noch verhindern.",
      "review": "Grundsätze",
      "reviewWhy": "wenn der Kampf natürlicher werden soll"
    },
    "igelburg": {
      "on": false,
      "name": "Igelburg",
      "kniff": "igelburg",
      "what": "Der frühere Kniff des Igels als Dickfell: Er rollt sich ein, nimmt weniger Schaden, und Gegner in der Nähe greifen eine Weile nur ihn an. Ausgeschaltet hat er stattdessen die Leibwache, mit denselben Zahlen; seine Äste gelten für die Leibwache.",
      "why": "Sie rollte ihn ein wie seine Passive; Fabi wollte die Leibwache als Kniff dort, wo ein Kniff noch nicht überzeugt hat.",
      "review": "Inhalte",
      "reviewWhy": "wenn die Kniffe aller Spezies festgelegt werden; die Leibwache bleibt für die erste Fassung (29.10.2026)"
    },
    "nieselchenAlt": {
      "on": false,
      "name": "Nieselchen wie bisher",
      "what": "Das Nieselchen springt gleich zu Kampfbeginn zum Schwächsten in der zweiten Reihe, schlägt ein paarmal zu und springt zurück; sein Kniff ist ein einzelner Hieb mit dem Blattschwert.",
      "why": "Fabi hat es neu gedacht: Es springt erst mit seinem Kniff, schlägt zweimal zu, versteckt sich hinter einem stärkeren Sturmwesen und wirft von dort Blätter.",
      "review": "Grundsätze",
      "reviewWhy": "falls das neue Nieselchen nicht trägt"
    },
    "raufboldTrotz": {
      "on": true,
      "name": "Trotz der Raufbolde",
      "what": "Versuch: Jeder Raufbold schlägt kräftiger zu, je weniger Leben er hat, kurz vor dem Ende um bis zu 40 %.",
      "why": "Fabi wollte es eigentlich als Ast; im Kern probieren wir es als Merkmal der ganzen Klasse.",
      "review": "Inhalte",
      "reviewWhy": "bleibt für die erste Fassung an (29.10.2026, die Bilder dazu gibt es); in der Phase Inhalte entscheiden, ob es ein Ast wird"
    },
    "itemSpread": {
      "on": false,
      "name": "Items streuen",
      "what": "Die Zahlen eines Items werden beim Finden in einem Rahmen gewürfelt. Ausgeschaltet hat jedes Item feste Zahlen; besondere Items gibt es weiter, mit einem Wort vor dem Namen statt Stern.",
      "why": "Man musste Zahlen vergleichen, statt zu wissen, was ein Item kann.",
      "review": "Inhalte",
      "reviewWhy": "zusammen mit besonderen Items mit Nebeneigenschaft"
    },
    "uebungsufer": {
      "on": false,
      "name": "Übungsufer",
      "what": "Ein fester Kampf mit Pause, Befehlen und Kniffen auf Befehl, neben dem Run (K46 bis K52), auf der Startseite und im Menü. Ausgeschaltet sind Knopf und Menüeintrag weg; Code, Daten und Tests bleiben.",
      "why": "Fabi (29.10.2026): Der Kampf bleibt aufstellen und zuschauen (K53); Pause und Befehle kommen nicht in den Run. Die erste Fassung soll rund sein und nichts zeigen, was nicht dazugehört.",
      "review": "Grundsätze",
      "reviewWhy": "falls es nach der ersten Fassung weitergeht: mit dem Kampf-Designer, ob Pause und Befehle doch in den Run kommen"
    }
  },
  "traits": {
    "off": ["unruhig", "verpeilt"],
    "why": "Unruhig macht den Fokus unberechenbar, Verpeilt ist reiner Münzwurf; beides sieht man ohne Grafik kaum.",
    "review": "Vertical Slice",
    "reviewWhy": "wenn man Eigenschaften im Bild erkennt"
  },
  "items": {
    "off": ["mooskissen", "eichelhut", "morgentau", "flusskiesel", "schleifstein", "moossohlen", "fingerhutkranz"],
    "why": "Fabi: „Items waren mir zu viel“; aus sind die sieben, die man am seltensten nehmen möchte, weil sie nicht spannend sind (Fabi, 16.10.2026): kleine unsichtbare Zahlen oder ein anderes Item noch einmal.",
    "review": "Inhalte",
    "reviewWhy": "wenn die Liste der Items für das ganze Spiel festgelegt wird"
  },
  "reduced": [
    {
      "name": "Eigenschaften der Sturmwesen",
      "what": "Etwa jedes vierte Sturmwesen hat eine Eigenschaft, nie zwei.",
      "before": "fast jedes zweite, manchmal zwei",
      "why": "Man musste bei jedem Gegner lesen, was er Besonderes kann.",
      "review": "Vertical Slice",
      "reviewWhy": "wenn man Eigenschaften im Bild erkennt"
    },
    {
      "name": "Arten von Sturmwesen in einem Kampf",
      "what": "Höchstens drei, der Boss zählt mit.",
      "before": "so viele, wie die Punkte hergaben",
      "why": "Zu viele verschiedene Gegner auf einmal (Fabi: „höchstens 3 Arten“).",
      "review": "Inhalte",
      "reviewWhy": "wenn jedes Biom seine eigenen Gegner hat"
    }
  ]
}
